import React, { useEffect } from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';

import { useStores } from '../../hooks/use-stores';

const OrderHeader = observer(() => {
    const { ProfileOrderStore: store, HeaderStore } = useStores();
    const { order } = store || {};
    const { opportunity, beginDate, closeDate } = order || {};

    useEffect(() => HeaderStore.setTitle(`Заказ ${order?.id}`), [HeaderStore, order]);

    return (
        <div className="wrap-small-info-card">
            <div className="small-info-card">
                <div className="small-info-card__title">Сумма заказа</div>
                <div className="small-info-card__wrap-content">
                    <span className="small-info-card__big-text small-info-card__big-text small-info-card__big-text--fz-45">
                        {opportunity}
                    </span>
                    <span className="small-info-card__small-text">руб.</span>
                </div>
            </div>
            <div className="small-info-card">
                <div className="small-info-card__title">Даты аренды</div>
                <div className="small-info-card__wrap-content">
                    <span className="small-info-card__big-text small-info-card__big-text small-info-card__big-text--date-group">
                        {moment(beginDate).isValid() ? moment(beginDate).format('DD.MM.YY') : 'Не указано'} -
                        {moment(closeDate).isValid() ? moment(closeDate).format('DD.MM.YY') : 'Не указано'}
                    </span>
                    <span className="small-info-card__small-text" />
                </div>
            </div>
            <div className="small-info-card">
                <div className="small-info-card__title">
                    {moment().diff(moment(closeDate)) > 0 ? 'Аренда завершена' : 'Аренда завершится'}
                </div>
                <div className="small-info-card__wrap-content">
                    <span className="small-info-card__big-text small-info-card__big-text small-info-card__big-text--date-group">
                        {moment(closeDate).isValid() ? moment(closeDate).fromNow() : 'Не указано'}
                    </span>
                </div>
            </div>
        </div>
    );
});

export default OrderHeader;
